import {
  TJobValuesOverlay, TOverlayBucketSize,
} from '../interface/job-values.ts';

const overlayOptions: Record<TJobValuesOverlay, string> = {
  shewhart: 'Shewhart',
  distribution: 'Rozdelenie',
  average: 'Priemer',
  median: 'Medián',
  nothing: 'Bez prekrytia',
};

const overlayBucketSizeOptions: Record<TOverlayBucketSize, string> = {
  total: 'Celkovo',
  year: 'Rok',
  quarter: 'Kvartál',
  month: 'Mesiac',
  week: 'Týždeň',
};

export default {
  rollingAverageSize: 'Veľkosť kĺzavého priemeru',
  showRollingAverage: 'Kĺzavý priemer',
  selectOverlay: 'Prekrytie',
  showOverlayLabel: 'Popis',
  overlayBucketSize: 'Časové okno',
  overlayOptions,
  overlayBucketSizeOptions,
};
